/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CustomProfileFieldsEditor_organization$ref = any;
type CustomProfileFieldsList_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AboutTab_organization$ref: FragmentReference;
declare export opaque type AboutTab_organization$fragmentType: AboutTab_organization$ref;
export type AboutTab_organization = {|
  +name: string,
  +isPubliclyVisible: boolean,
  +$fragmentRefs: CustomProfileFieldsEditor_organization$ref & CustomProfileFieldsList_organization$ref,
  +$refType: AboutTab_organization$ref,
|};
export type AboutTab_organization$data = AboutTab_organization;
export type AboutTab_organization$key = {
  +$data?: AboutTab_organization$data,
  +$fragmentRefs: AboutTab_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboutTab_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPubliclyVisible",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomProfileFieldsEditor_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomProfileFieldsList_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e1bd22b016c8834e1b144909d94663e7';

module.exports = node;
